import './RoundedImage.scss';

export type RoundedImageSizes = 'xs' | 'sm' | 'md' | 'lg';

interface RoundedImageProps {
  /**
   * The URL of the image
   */
  src: string;
  /**
   * Defines an alternative text description of the image.
   */
  alt: string;
  size?: RoundedImageSizes;
  className?: string;
}

/**
 * Avatar UI component
 */
export default function RoundedImage({ src, alt, size = 'md', className = '' }: RoundedImageProps) {
  return (
    <div className={`rounded-image size-${size} ${className}`}>
      <img src={src} alt={alt} />
    </div>
  );
}
